var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.158,
    height: 36.766,
    viewBox: "0 0 38.158 36.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#000FFF;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1.002)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.849,23.013H28.29a.694.694,0,0,0,0,1.387H34.6l2.011,18.726H1.573L3.933,24.4h6.324a.694.694,0,1,0,0-1.387H2.71L0,44.513H38.158Z",
    transform: "translate(0 -6.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.325,27.334c-.1.06-.211.114-.309.177-.153.1-.3.2-.448.309a.694.694,0,0,0,.821,1.119c.123-.091.249-.178.38-.263a7.624,7.624,0,0,1,.7-.4.689.689,0,0,0,.32-.88c.006-.006.012-.01.017-.015a31.072,31.072,0,0,0,7.233-14.6,14.254,14.254,0,0,0,.237-4.8C31.684,3.413,28.851,1,24.088,1s-7.6,2.411-8.193,6.971a14.271,14.271,0,0,0,.238,4.8A31.124,31.124,0,0,0,23.325,27.334ZM17.27,8.154c.508-3.878,2.739-5.764,6.818-5.764s6.31,1.886,6.818,5.764a12.91,12.91,0,0,1-.219,4.333,30.515,30.515,0,0,1-6.6,13.626,30.522,30.522,0,0,1-6.6-13.626A12.91,12.91,0,0,1,17.27,8.154Z",
    transform: "translate(-4.838 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.5,15.423a5.095,5.095,0,1,0-5.095-5.095A5.1,5.1,0,0,0,25.5,15.423Zm0-8.8A3.708,3.708,0,1,1,21.8,10.329,3.712,3.712,0,0,1,25.5,6.621Z",
    transform: "translate(-6.254 -1.297)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.186,37.063a.694.694,0,0,0,.29,1.357c.406-.086.847-.159,1.308-.217a.693.693,0,1,0-.171-1.376C32.111,36.888,31.631,36.968,31.186,37.063Z",
    transform: "translate(-9.388 -10.976)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.6,37.231a.693.693,0,0,0,.692.664h.031l1.388-.058a.693.693,0,0,0,.661-.724.711.711,0,0,0-.724-.662l-1.384.058A.692.692,0,0,0,36.6,37.231Z",
    transform: "translate(-11.215 -10.863)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.809,42.115c-.356.269-.725.528-1.1.768a.694.694,0,0,0,.756,1.164c.4-.258.793-.535,1.176-.824a.694.694,0,0,0-.836-1.108Z",
    transform: "translate(-6.251 -12.556)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M44.063,35.5a2.472,2.472,0,0,1-.934.365.694.694,0,1,0,.281,1.359,3.814,3.814,0,0,0,1.454-.592l.093-.068a.694.694,0,0,0-.837-1.106Z",
    transform: "translate(-13.047 -10.516)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.2,43.015a.693.693,0,0,0-1.339-.362,4.639,4.639,0,0,0-.156.974c0,.08-.006.16-.006.245,0,.136.007.272.02.407a.694.694,0,0,0,.689.623c.023,0,.046,0,.071,0a.7.7,0,0,0,.62-.761c-.01-.091-.013-.183-.014-.27,0-.058,0-.115,0-.172A3.231,3.231,0,0,1,8.2,43.015Z",
    transform: "translate(-2.052 -12.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.744,27.795a4.079,4.079,0,0,0-1.655.126.694.694,0,0,0,.188,1.361.677.677,0,0,0,.189-.026,2.707,2.707,0,0,1,1.092-.085.694.694,0,0,0,.186-1.375Z",
    transform: "translate(-12.743 -8.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M46.66,31.947a.693.693,0,0,0,.458.867.679.679,0,0,0,.2.031.692.692,0,0,0,.662-.489,2.955,2.955,0,0,0,.127-.668c0-.058.006-.116.006-.173a2.768,2.768,0,0,0-.177-.965.693.693,0,0,0-1.3.482,1.39,1.39,0,0,1,.09.483l0,.081A1.564,1.564,0,0,1,46.66,31.947Z",
    transform: "translate(-14.279 -8.916)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.741,45.135c-.406.191-.82.368-1.23.526A.694.694,0,0,0,15.761,47a.686.686,0,0,0,.25-.046c.44-.17.884-.36,1.32-.564a.694.694,0,0,0-.59-1.257Z",
    transform: "translate(-4.617 -13.504)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.894,40.259a.693.693,0,0,0,.332-.085,1.7,1.7,0,0,1,.632-.2,1.125,1.125,0,0,1,.282,0,.693.693,0,1,0,.182-1.375,2.561,2.561,0,0,0-.618-.006,3.083,3.083,0,0,0-1.142.361.694.694,0,0,0,.333,1.3Z",
    transform: "translate(-2.819 -11.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.764,48.239a3.435,3.435,0,0,0,.454.086,4.43,4.43,0,0,0,.533.033,5.145,5.145,0,0,0,.652-.043.693.693,0,0,0-.173-1.376,3.4,3.4,0,0,1-.843.01,2.312,2.312,0,0,1-.273-.052.693.693,0,1,0-.349,1.342Z",
    transform: "translate(-2.833 -14.057)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapa);
export default __webpack_public_path__ + "static/media/mapa.56a12a628f8586419ae8c09f790d2640.svg";
export { ForwardRef as ReactComponent };